export default "__VITE_ASSET__6dC62U9a__"